import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "onboarding-product-demo__text" }

import { computed, ref, watch } from 'vue'

import { getImage } from '@/models/onboarding'
import type { QuestionnaireView } from '@/models/onboarding'
import type { ProductDemoPage } from '@/models/onboarding.types'
import { platform } from '@/services/platform'

import Rive from '@/app/components/Rive.vue'
import Layout from '../Layout.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductDemo',
  props: {
    view: {}
  },
  setup(__props: any) {

const props = __props

const riveRef = ref<InstanceType<typeof Rive> | null>(null)

const showText = ref(false)

const page = computed(() => {
  return props.view.currentPage as ProductDemoPage
})

const currentSection = computed(() => {
  return props.view.currentSubpageIndex
})

const currentText = computed(() => {
  return page.value.content[currentSection.value]
})

const animation = computed(() => {
  return platform.isDesktopWidth()
    ? page.value.animationDesktop
    : page.value.animationMobile
})

const defaultSlotScroll = computed(() => {
  if (platform.isDesktopWidth()) {
    return 0
  }
  // This effectively anchors the Rive element
  // to the bottom of the container, as if the
  // container had `align-items: flex-end`, but
  // with a transition (`align-items` can't have
  // CSS transitions). The `9999` value is a high
  // enough number that should scroll to the bottom
  // on any screen.
  return currentSection.value >= 2 ? 9999 : 0
})

function nextSection(): void {
  showText.value = true

  // Wait for the text fade-out animation
  // before showing the continue buttton.
  setTimeout(() => {
    props.view.showContinueButton()
  }, 500)
}

watch(currentSection, () => {
  // When the user clicks "Continue",
  // hide the text and the "Continue"
  // button.
  if (!platform.isDesktopWidth()) {
    showText.value = false
  }
  props.view.hideContinueButton()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Layout, {
    class: _normalizeClass(["onboarding-product-demo", {
      'onboarding-product-demo--loaded': riveRef.value?.isLoaded,
      [`onboarding-product-demo--step-${currentSection.value}`]: riveRef.value?.isLoaded,
    }]),
    title: page.value.title,
    scrollTop: defaultSlotScroll.value
  }, {
    default: _withCtx(() => [
      _createVNode(_Transition, {
        name: "fade",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          (showText.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: currentText.value,
                class: "onboarding-product-demo__text-wrapper"
              }, [
                _createElementVNode("p", _hoisted_1, _toDisplayString(currentText.value), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(Rive, {
        ref_key: "riveRef",
        ref: riveRef,
        class: "onboarding-product-demo__rive",
        animations: `${currentSection.value}`,
        src: _unref(getImage)(animation.value.src),
        width: animation.value.width,
        height: animation.value.height,
        onStop: nextSection
      }, null, 8, ["animations", "src", "width", "height"])
    ]),
    _: 1
  }, 8, ["class", "title", "scrollTop"]))
}
}

})